<template>
	<b-row class="my-2">
		<b-col>
			<span class="font-weight-bold">{{ label }}</span>
			<ul class="mt-2">
				<li v-for="item in items" :key="item">
					{{ item }}
				</li>
				<li v-if="items.length == 0" class="ml-2 font-weight-bold font-italic">nincs</li>
			</ul>
		</b-col>
	</b-row>
</template>
<script>
	export default {
		name: 'unordered-list',
		props: ['label', 'items']
	}
</script>
